function methods(name,value,names,{optional=false}={}){
  if(value==null&&optional)return null;
  if(!value||typeof value!=='object')throw new TypeError(name+' is required');
  for(const method of names)if(typeof value[method]!=='function')throw new TypeError(name+'.'+method+'() is required');
  return value;
}
export const requireContextProvider=value=>methods('ContextProvider',value,['resolve','assemble']);
export const requireEvidenceSource=value=>methods('EvidenceSource',value,['references']);
export const requireSafetyKnowledgeProvider=(value,options)=>methods('SafetyKnowledgeProvider',value,['retrieve'],options);
export const requireAssistantProvider=(value,options)=>methods('AssistantProvider',value,['respond'],options);
export const requireAssistantPolicy=value=>methods('AssistantPolicy',value,['route','topics','localResponse','safetyResponse','fallback','validate','envelope','consentRequired','providerUnavailable']);
export function createEvidenceReference({kind,ref,observedAt=null}={}){
  if(typeof kind!=='string'||!kind.trim()||typeof ref!=='string'||!ref.trim())throw new TypeError('Evidence reference requires kind and ref');
  if(observedAt!=null&&Number.isNaN(Date.parse(observedAt)))throw new TypeError('Invalid evidence timestamp');
  return Object.freeze({kind:kind.trim(),ref:ref.trim(),observedAt});
}
export function createAssistantConsent({privateTextNeeded=false,privateTextConsent=false,providerProcessingConsent=false}={},{
  privateTextErrorCode='ASSISTANT_PRIVATE_TEXT_CONSENT_REQUIRED'
}={}){
  if(privateTextNeeded===true&&privateTextConsent!==true)throw new Error(privateTextErrorCode);
  return Object.freeze({privateTextIncluded:privateTextNeeded===true&&privateTextConsent===true,providerProcessingConsent:providerProcessingConsent===true,conversationRetention:'ephemeral_memory'});
}
